import React from 'react';
import looppa from 'looppa';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';

import { FAQ } from 'constants/page-names';
import Button from 'components/button';
import ContactInfo from 'components/contact-info';
import { Trans } from 'translations';
import { headerTooltip } from 'constants/menus';

function HeaderTooltip({ routerRegistry }) {
    return (
        <aside className="header-tooltip">
            <h1 className="header-tooltip--title u-reset">{routerRegistry.get(FAQ).title}</h1>
            <Button tag="a" to={routerRegistry.get(FAQ).url} className="header-tooltip--button" facet="primary" size="small">
                <Trans path="header.tooltip.questions.button"/>
            </Button>
            <ContactInfo/>
            <ul className="header-tooltip--menu u-reset">
                {looppa(headerTooltip())((item, i) => (
                    <li className="header-tooltip--menu-item" key={i}>
                        <Link className="header-tooltip--menu-link u-reset" to={item.url}>{item.title}</Link>
                    </li>
                ))}
            </ul>
        </aside>
    );
}


HeaderTooltip.propTypes = {
    routerRegistry: PropTypes.object.isRequired,
};

export default connect(
    reduxUtils.mapStateToProps({
        routerRegistry: 'router.registry',
    }),
)(HeaderTooltip);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/pre-header/header-tooltip/index.js